import React from 'react'
import { TextField } from '@material-ui/core'
import { Autocomplete } from '@material-ui/lab'

type FilterFieldProps = {
  options: string[]
  label: string
  onChange: (
    event: React.ChangeEvent<Record<string, unknown>>,
    value: string[],
  ) => void
  defaultValue: string[]
}

export const FilterField: React.FC<FilterFieldProps> = ({
  label,
  options,
  onChange,
  defaultValue,
}) => (
  <Autocomplete
    multiple
    defaultValue={defaultValue}
    style={{ marginBottom: 20 }}
    options={options}
    filterSelectedOptions
    renderInput={(params) => (
      <TextField {...params} variant="outlined" label={label} />
    )}
    onChange={onChange}
  />
)
